import { render, staticRenderFns } from "./WithdrawGuide.vue?vue&type=template&id=618783d4&scoped=true"
import script from "./WithdrawGuide.vue?vue&type=script&lang=js"
export * from "./WithdrawGuide.vue?vue&type=script&lang=js"
import style0 from "./WithdrawGuide.vue?vue&type=style&index=0&id=618783d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618783d4",
  null
  
)

export default component.exports